<script>
  // Single vs Multi mode segmented toggle.
  // Single = only the current tab is shown, tab bar hidden.
  // Multi  = tab bar visible, can add/close tabs per key.
  import { getMode, setMode } from "../stores/app.svelte.js";
  const mode = $derived(getMode());
</script>

<div class="mode-toggle">
  <button class:active={mode === "single"} onclick={() => setMode("single")}>
    🪞 Single generator
  </button>
  <button class:active={mode === "multi"}  onclick={() => setMode("multi")}>
    🗂️ Multi generator
  </button>
</div>

<style>
  .mode-toggle {
    max-width: min(1400px, 96vw);
    margin: 12px auto 0;
    padding: 0 20px;
    display: inline-flex;
    gap: 4px;
    padding: 4px;
    background: var(--panel-2);
    border-radius: 8px;
    border: 1px solid var(--border);
    width: fit-content;
    align-self: flex-start;
  }

  button {
    padding: 6px 14px;
    border-radius: 6px;
    font-size: 0.8rem;
    color: var(--muted-strong);
    transition: background 0.15s, color 0.15s;
  }

  button.active {
    background: var(--panel);
    color: var(--text-strong);
  }
</style>
